import { render, staticRenderFns } from "./AppraisalCard.vue?vue&type=template&id=354bc858&scoped=true"
import script from "./AppraisalCard.vue?vue&type=script&lang=js"
export * from "./AppraisalCard.vue?vue&type=script&lang=js"
import style0 from "./AppraisalCard.vue?vue&type=style&index=0&id=354bc858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bc858",
  null
  
)

export default component.exports